document.addEventListener("DOMContentLoaded", () => {
  // let wishlist = JSON.parse(localStorage.getItem("origin-roasting__wishlist")) || [];
  const customerDataElement = document.getElementById("customer-data");
  // const loadingMessage = document.getElementById("wishlist-loading");
  // const cartBtns = document.querySelectorAll(`[id^="cart-wishlist"]`);
  // const wishlistHandlesElement = document.getElementById("wishlist-handles");
  // const wishlistHeaderElement = document.getElementById("wishlist-headers");
  // const alertBanner = document.getElementById("alert-banner");
  // const removeLinks = document.querySelectorAll(".js-remove-item");

  function enableOtherButtons() {
    cartBtns.forEach((btn) => {
      btn.disabled = false; // Enable buttons
      btn.classList.remove('disabled');
    });
  }

  if (!customerDataElement) {
    console.warn("Required script tags not found");
    return;
  }

  const customerData = JSON.parse(customerDataElement.textContent);

  function extractProductInfo(obj) {
    return Array.from({ length: obj.records }).map((_, i) => ({
      product_id: Number(obj.product_id[i]),
      product_handle: obj.product_handle[i],
      proimage: obj.product_img[i],
      protitle: obj.product_name[i],
      vname: obj.variant_name[i],
      proprice: obj.product_price[i],
      checked: true,
    }));
  }

  function loadZooomyData(customerId) {
    console.log(customerId, 'customerID')
    const ZooomyDataFun = (B, J, M) => {
      B.ajax({
        url: "https://zooomyapps.com/wishlist/ListWishlist.php",
        data: { shop: J, customerid: M },
        dataType: "jsonp",
        jsonp: "ZooomyGetDataPage",
        async: "true",
        success: (n) => {
          wishlist = extractProductInfo(n);
          updateWishlistStorage();
        },
        error: (t) => console.log(t, "t"),
      });
    };

    if (typeof window.jQuery === "undefined") {
      loadJQuery(() =>
        ZooomyDataFun(
          window.jQuery.noConflict(true),
          "origin-roasting.myshopify.com",
          customerId
        )
      );
    } else {
      ZooomyDataFun(
        window.jQuery,
        "origin-roasting.myshopify.com",
        customerId
      );
    }
  }

  if (customerData) {
    loadZooomyData(customerData.customer_id);
  }


  function updateWishlistStorage() {
    localStorage.setItem("origin-roasting__wishlist", JSON.stringify(wishlist));
    fetchProductData();
  }
});